import { BrandPalette } from '@tcl-boron-colors/colors';
import * as typography from '@tcl-boron-styles/typography/dist/index.module.scss';
import cn from 'classnames';
import React, { ComponentType, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  root: {
    width: 380,
    display: 'flex',
    margin: '0 auto',
    textAlign: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: BrandPalette[700],
  },
  title: {
    marginTop: 16,
  },
  description: {
    marginTop: 16,
  },
});

interface NotAvailableProps {
  title?: ReactNode;
  description?: ReactNode;
  Image?: ComponentType<React.SVGProps<SVGSVGElement>>;
  className?: string;
}

export const NotAvailable: React.FC<NotAvailableProps> = ({ title, description, Image, className }) => {
  const classes = useStyles();

  return (
    <div className={cn(classes.root, className)}>
      {Image && <Image />}
      {title && <div className={`${classes.title} ${typography.sectionHeader}`}>{title}</div>}
      {description && <div className={`${classes.description} ${typography.body}`}>{description}</div>}
    </div>
  );
};
